<ng-container *ngIf="!isReply">
  <ng-container
    *ngIf="
      message?.createdBy.appUserId !==
        messages[index - 1]?.createdBy.appUserId &&
      message?.createdBy.appUserId == 'ncc-admin'
    "
  >
    <div class="chat-info">
      <p style="margin-top: 14px !important">
        {{ message?.createdBy.name }} joined live chat
      </p>
      <p style="margin-bottom: 14px !important">
        Messages are being watched by NCC Admin Staff
      </p>
    </div>
  </ng-container>
</ng-container>
<div
  class="comment-container"
  fxLayout="column"
  fxLayoutGap="44px"
  fxLayoutAlign="start center"
  appMargin
  [marginB]="!isReply ? '40px' : '0px'"
>
  <!-- shows comments content for user is currentuser and with no replies -->
  <div
    class="current-user"
    *ngIf="
      message?.createdBy.appUserId == 'public' && !message?.parentCommentId
    "
  >
    <div class="comment-header">
      <span
        class="reply-text clickable"
        *ngIf="!isReply"
        (click)="replyMessage(message)"
        >Reply</span
      >
      <div class="user-info">
        <span class="user-name">{{ userEmail }}</span>
        <img class="user-photo" src="assets/avatar/1.jpg" />
      </div>
    </div>
    <div class="content-area">
      <quill-view-html
        [content]="message.comment"
        theme="snow"
      ></quill-view-html>
      <span class="comment-time">
        {{ message?.dateCreated | date: "h:mm a" }}
      </span>
    </div>

    <!-- for comment with attachment file -->
    <div
      *ngIf="message.documentMetadata"
      [href]="secureDocumentUrl"
      target="_blank"
    >
      <div
        class="attachment-field clickable"
        (click)="viewDocument(dataToJSON(message?.documentMetadata))"
      >
        <span class="text">{{
          dataToJSON(message?.documentMetadata)?.documentName
        }}</span>
        <img
          class="icon"
          src="../../../../../../assets/icons/basil_document-outline.svg"
          alt="document icon"
        />
      </div>
    </div>
  </div>

  <!-- show comment block with parent comment and comment view,
        that is if user is current user and created a reply -->
  <div
    class="current-user"
    *ngIf="message?.createdBy.appUserId == 'public' && message?.parentCommentId"
  >
    <div class="comment-header">
      <span
        class="reply-text clickable"
        *ngIf="!isReply"
        (click)="replyMessage(message)"
        >Reply</span
      >
      <div class="user-info">
        <span class="user-name">{{ userEmail }}</span>
        <img class="user-photo" src="assets/avatar/1.jpg" />
      </div>
    </div>
    <div class="content-area">
      <div class="reply-block" *ngIf="message.parentCommentId">
        <span class="parent-data">
          {{
            (dataToJSON(message.parentCommentMetadata)?.createdBy
              | createdBy) ||
              (dataToJSON(message.parentCommentMetadata)?.createdBy
                | createdByApp)
          }}
        </span>
        <quill-view-html
          [content]="message.parentCommentMetadata | parentMeta"
          theme="snow"
        ></quill-view-html>
      </div>

      <quill-view-html
        [content]="message.comment"
        theme="snow"
      ></quill-view-html>
      <span class="comment-time">
        {{ message?.dateCreated | date: "h:mm a" }}
      </span>
    </div>

    <!-- for comment with attachment file -->
    <div
      *ngIf="message.documentMetadata"
      [href]="secureDocumentUrl"
      target="_blank"
    >
      <div
        class="attachment-field clickable"
        (click)="viewDocument(dataToJSON(message?.documentMetadata))"
      >
        <span class="text">{{
          dataToJSON(message?.documentMetadata)?.documentName
        }}</span>
        <img
          class="icon"
          src="../../../../../../assets/icons/basil_document-outline.svg"
          alt="document icon"
        />
      </div>
    </div>
  </div>
  <!-- shows comments header for user not currentuser -->
  <!-- <div
    class="other-user no-margin"
    *ngIf="user.username != message?.createdBy.appUserId"
  >
    <div class="comment-header">
      <div class="user-info">
        <span class="user-name">{{ message?.createdBy.appUserId }}</span>
        <img class="user-photo" src="assets/images/ncc-logo.svg" />
      </div>
      <span
        class="reply-text clickable"
        *ngIf="!isReply"
        (click)="replyMessage(message)"
        >Reply</span
      >
    </div>
  </div> -->

  <!-- shows comments content for user not currentuser and with no replies -->
  <div
    class="other-user"
    *ngIf="
      message?.createdBy.appUserId !== 'public' && !message?.parentCommentId
    "
  >
    <div class="comment-header">
      <div class="user-info">
        <!-- <span class="user-name">{{
          message?.createdBy.name }}</span> -->

        <span class="user-name">{{ "NCC Representative" }}</span>

        <img class="user-photo" src="assets/images/ncc-logo.svg" />
        <!-- <img
          class="user-photo"
          *ngIf="message?.createdBy?.image"
          [src]="loadImage(message?.createdBy)"
        /> -->
      </div>
      <span
        class="reply-text clickable"
        *ngIf="!isReply"
        (click)="replyMessage(message)"
        >Reply</span
      >
    </div>
    <div class="content-area">
      <quill-view-html
        [content]="message.comment"
        theme="snow"
      ></quill-view-html>
      <span class="comment-time">
        {{ message?.dateCreated | date: "h:mm a" }}
      </span>
    </div>

    <!-- for comment with attachment file -->
    <div
      *ngIf="message.documentMetadata"
      [href]="secureDocumentUrl"
      target="_blank"
    >
      <div
        class="attachment-field clickable"
        (click)="viewDocument(dataToJSON(message?.documentMetadata))"
      >
        <span class="text">{{
          dataToJSON(message?.documentMetadata)?.documentName
        }}</span>
        <img
          class="icon"
          src="../../../../../../assets/icons/basil_document-outline.svg"
          alt="document icon"
        />
      </div>
    </div>
  </div>

  <!-- show comment-reply block if not current user -->
  <div
    class="other-user"
    *ngIf="message?.createdBy.appUserId !== 'public' && message.parentCommentId"
  >
    <div class="comment-header">
      <div class="user-info">
        <!-- <span class="user-name">{{ message?.createdBy.name }}</span> -->
        <span class="user-name">{{ "NCC Representative" }}</span>
        <img class="user-photo" src="assets/images/ncc-logo.svg" />
        <!-- <img
          class="user-photo"
          *ngIf="message?.createdBy?.image"
          [src]="loadImage(message?.createdBy)"
        /> -->
      </div>
      <span
        class="reply-text clickable"
        *ngIf="!isReply"
        (click)="replyMessage(message)"
        >Reply</span
      >
    </div>
    <div class="content-area">
      <div class="reply-block">
        <span class="parent-data">
          {{
            (dataToJSON(message.parentCommentMetadata)?.createdBy
              | createdBy) ||
              (dataToJSON(message.parentCommentMetadata)?.createdBy
                | createdByApp)
          }}
        </span>
        <quill-view-html
          [content]="message.parentCommentMetadata | parentMeta"
          theme="snow"
        ></quill-view-html>
      </div>

      <quill-view-html
        [content]="message.comment"
        theme="snow"
      ></quill-view-html>
      <span class="comment-time">
        {{ message?.dateCreated | date: "h:mm a" }}
      </span>
    </div>

    <!-- for comment with attachment file -->
    <div
      *ngIf="message.documentMetadata"
      [href]="secureDocumentUrl"
      target="_blank"
    >
      <div
        class="attachment-field clickable"
        (click)="viewDocument(dataToJSON(message?.documentMetadata))"
      >
        <span class="text">{{
          dataToJSON(message?.documentMetadata)?.documentName
        }}</span>
        <img
          class="icon"
          src="../../../../../../assets/icons/basil_document-outline.svg"
          alt="document icon"
        />
      </div>
    </div>
  </div>
</div>

<!-- <div style="align-self: flex-start" *ngIf="isReply">
  <span style="font-weight: 600"> {{ replyMsg?.createdBy.appUserId }} </span>
  <quill-view-html [content]="replyMsg?.comment" theme="snow"></quill-view-html>
</div> -->
